import { Box } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

const SplitFlowContainer: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box
    css={{
      display: 'grid',
      sm: {
        gridTemplateColumns: '1fr',
      },
      lg: {
        gridTemplateColumns: '2fr 3fr',
        position: 'fixed',
        top: '0',
        bottom: '0',
        right: '0',
        left: '0',
      },
    }}
  >
    {children}
  </Box>
);

const ImagePane: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box
    css={{
      width: '100%',
      sm: {
        maxHeight: '40vh',
      },
      lg: {
        maxHeight: '100vh',
        gridRow: '1 / 3',
      },
    }}
  >
    {children}
  </Box>
);

const imageClass = css({
  backgroundColor: 'primitives.teal.50',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  objectPosition: 'center',
});

const Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ alt, ...props }) => (
  <img alt={alt} className={imageClass} {...props} />
);

const Content: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box
    css={{
      display: 'grid',
      gap: 'space.400',
      lg: {
        maxHeight: '100vh',
        overflow: 'auto',
        gridColumn: '2 / 3',
      },
    }}
  >
    {children}
  </Box>
);

const Header: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box
    css={{
      width: '100%',
      borderBottom: 'solid 1px',
      borderColor: 'border',
      lg: {
        gridColumn: '2 / 3',
      },
    }}
  >
    {children}
  </Box>
);

const Root: React.FC<React.PropsWithChildren<{ css?: SystemStyleObject }>> = ({ children, css: cssProp }) => (
  <Box
    css={{
      containerType: 'inline-size',
      ...cssProp,
    }}
  >
    <SplitFlowContainer>{children}</SplitFlowContainer>
  </Box>
);

const SplitFlow = Object.assign(Root, { Image, ImagePane, Content, Header });

SplitFlow.Image.displayName = 'SplitFlow.Image';
SplitFlow.ImagePane.displayName = 'SplitFlow.ImagePane';
SplitFlow.Content.displayName = 'SplitFlow.Content';
SplitFlow.Header.displayName = 'SplitFlow.Header';
SplitFlow.displayName = 'SplitFlow';

export default SplitFlow;
